export function formDataToJson(formData: FormData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formDataJson: any = {};
    if (!formData.forEach) {
        return {};
    }
    formData.forEach(function (value, key) {
        formDataJson[key] = value;
    });
    return formDataJson;
}
